export default {
  taskTitList: ['校考考試', '聯考考試'],
  year: '學年學期',
  grade: '年級',
  examType: '考試類型',
  examName: '考試名稱',
  ji: '級',
  shouqi: '收起',
  zhankai: '展開',
  examTime: '考試時間',
  unPuSub: '未發布學科',
  clear: '清理',
  isSchool: '學校可見',
  isRank: '排名可見',
  isParent: '家長可見',
  isStudent: '學生查詢成績',
  downAll: '考試整體分析表下載',
  downOne: '獨立分析表下載',
  comparison: '數據對比',
  downSelf: '下載個性報表',
  studentCount: '考試人數',
  totalScore: '總分',
  avgScore: '平均分',
  maxScore: '最高分',
  minScore: '最低分',
  overAverageRate: '超均率',
  overAverageNumber: '超均人數',
  standardDeviation: '標準差',
  difficulty: '難度',
  discrimination: '區分度',
  DataContrast: '選擇歷次考試數據對比考試',
  testName: '當前考試名稱',
  derectTest: '直接對比考試',
  inderectTest: '直接對比考試',
  derectTip:
    '表格中會把當前考試與該次考試的成績進行直接對比，得出學生進退步及班級（年級）維度的升降數據。',
  inderectTip:
    '表格中會把當前考試與所選考試的成績進行間接對比，得出學生進退步及班級（年級）維度的升降數據。',
  placeholder1: '請選擇直接對比考試',
  placeholder2: '請選擇間接對比考試',
  studentTitle: '學生查詢地址',
  studentCan: '學生可見',
  studentCanTip: '學生可以通過訪問本地址且登錄後查詢本次考試總分及各學科成績',
  lang: '選擇語言',
  searchLink: '查詢地址',
  copy: '復製',
  langList: ['簡體', '繁體'],
  examTypeList: [
    '全部',
    '練習',
    '周考',
    '月考',
    '期中考試',
    '期末考試',
    '模擬考試'
  ],
  meTypeList: ['所有考試', '全科', '文科', '理科'],
  gradeList: ['全部'],
  examList: ['所有考試'],
  examGradeList: [
    '一年級',
    '二年級',
    '三年級',
    '四年級',
    '五年級',
    '六年級',
    '初一',
    '初二',
    '初三',
    '高一',
    '高二',
    '高三'
  ],
  copysucess: '查詢地址已復製到粘貼板',
  ztsucess: '狀態修改成功',
  sucess: '修改成功',
  hcsucess: '緩存清理成功',
  directExam: '間接對比考試最多選擇兩場考試！',
  unallcourse: '全科並沒有全部發布成績，暫時沒有數據！',
  doenFail: '下載失敗',
  allCourse: '全科',
  meExamType: [
    '練習考試',
    '周考試',
    '月考試',
    '期中考試',
    '期末考試',
    '模擬考試'
  ],
  //全科和单科页面
  seNameTit: '_數據報表',
  label1: '所屬校區',
  label2: '組別',
  label3: '班級',
  label4: '考試科目',
  alertText:
    '本科目所有題塊未批閱完成，由於您提前匯總、發布了成績，所以下述報表不一定是完整的，請知曉~',
  fen: '分',
  ren: '人',
  toptext1: '卷面滿分',
  toptext2: '難度值',
  toptext3: '區分度',
  gradeTit: ['年', '級', '概', '況'],
  classTit: ['班', '級', '概', '況'],
  topList: [
    '年級參考',
    '年級最高分',
    '年級最低分',
    '年級均分',
    '年級超均率',
    '年級標準差'
  ],
  classtopList: [
    '班級參考',
    '班級最高分',
    '班級最低分',
    '班級均分',
    '班級超均率',
    '班級標準差'
  ],
  notTabel: '暫無報表',
  overview1Tit: '均分離差分析',
  downbtn: '下載',
  biao: '表',
  className: '班級',
  name: '姓名',
  classGroup: '班型',
  AvgScore: '平均分',
  BValue: 'B值',
  GradeRank: '年級排名',
  GroupRank: '同層排名',
  GroupScore: '同層分差',
  studentNum: '參考人數',
  ClassTeacher: '班主任',
  teacher: '教師',
  sortListTotal: [
    '學生成績散點圖',
    '學生成績單',
    '四分位分析',
    '均分分析',
    '均分離差分析',
    '四率分析',
    '分數線分析',
    '分數段分析',
    '位次段分析',
    '試卷整體分析',
    '試題得分趨勢',
    '試題得分表',
    '試題作答明細'
  ],
  contrastNav: ['學生進退步', '均分分析對比', '分數線分析對比'],
  schoolNav: [
    '小分表',
    '題目層次得分率',
    '題目層次得分率對比',
    '學生層次錯題表'
  ],
  sing: {
    downchart: '下載分析圖',
    exp: [
      '',
      '雙上線率=雙上線人數/參考人數',
      '學科命中率=雙上線人數/單科上線人數',
      '學科貢獻率=雙上線人數/總分上線人數'
    ]
  },
  singSub: '單科',
  singsubScore: '單科成績',
  studentPointChart: '線性回歸',
  finalScore: '最終成績單',
  scoreLine1: '前25%分數線',
  scoreLine2: '前50%分數線',
  scoreLine3: '前75%分數線',
  scoreNum: '分數',
  titleschool: '學校',
  average: '平均值',
  overviewScore: '離均分差',
  unionRank: '聯考排名',
  rateTitle: '比例(%)',
  peopleNum: '人數',
  ranking: '排名',
  twoN: '雙N',
  chartCtitle: ['雙%', '雙%', '命中', '貢獻'],
  titArr: [
    { linetitle: '單上線率', barTitle: '單上線人數' },
    { linetitle: '雙上線率', barTitle: '雙上線人數' },
    { linetitle: '學科命中率', barTitle: '雙上線人數' },
    { linetitle: '學科貢獻率', barTitle: '雙上線人數' }
  ],
  rankSeg: '位次',
  unionTitle: '聯考',
  scoreRate: '得分率',
  scoreRate1: '得分率(%)',
  chartMolum: [
    '題型',
    '題號',
    '參考人數',
    '滿分',
    '均分',
    '難度',
    '標準差',
    '最高分',
    '最低分',
    '滿分N',
    '滿分(%)',
    '部分N',
    '部分(%)',
    '零分N',
    '零分(%)'
  ],
  chartKolum: [
    '題號',
    '題名',
    '答案',
    '滿分',
    '年級平均分',
    '難度值',
    '均分',
    '得分率'
  ],
  scoreTableColum: [
    '班型',
    '班級',
    '姓名',
    '卷面分數',
    '班級排名',
    '年級排名',
    '客觀題得分',
    '主觀題得分'
  ],
  minScoreColum: ['題目', '題目層次', '平均得分率'],
  quesRateColum: [
    '班級',
    '題目層次',
    '題目',
    '班級平均分',
    '得分率(%)',
    '層次得分率(%)'
  ],
  allStuText: '整體學生',
  qusMOdalTit: '層次錯因分析',
  qusModalLabel: '展示條件',
  qustypeList: [
    {
      id: 1,
      name: '按錯因展示'
    },
    {
      id: 2,
      name: '按學生展示'
    }
  ],
  qusth: '層次得分率(%)',
  stunameLabel: '學生姓名',
  stunameplac: '請輸入學生姓名',
  stuErrorColum: ['姓名', '學科', '題目層次'],
  xiaoyang: '曉羊'
}
